import APP_ACTIONS from '../constants/app-actions';

const loader = {
    displayLoader: () => ({
        type: APP_ACTIONS.DISPLAY_LOADER,
    }),

    hideLoader: () => ({
        type: APP_ACTIONS.HIDE_LOADER,
    }),
};

export default loader;



/** WEBPACK FOOTER **
 ** ./src/actions/loader.js
 **/